import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../constants/constants";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { adminConfig } from "../../../utils/adminConfig";

const columns = [
  {
    name: "Contract ID",
    selector: (row) => row.contract,
    sortable: true,
    width: "130px",
  },
  {
    name: "Vacation Club",
    selector: (row) => row.vacationClub,
    sortable: true,
    width: "130px",
  },
  {
    name: "Member Name",
    selector: (row) => row.name,
    sortable: true,
    width: "140px",
  },
  {
    name: "Member Email",
    selector: (row) => row.email,
    sortable: true,
    width: "200px",
  },
  {
    name: "User Type",
    selector: (row) => row.userType,
    sortable: true,
    width: "160px",
  },
  {
    name: "Account Type",
    selector: (row) => row.accountType,
    sortable: true,
    width: "160px",
  },
  {
    name: "Active",
    selector: (row) => row.active,
    sortable: true,
    width: "130px",
  },
  {
    name: "First Activation Date",
    selector: (row) => moment(row.firstActivationDate).format(DATE_TIME_FORMAT),
    sortable: true,
    width: "200px",
  },
  {
    name: "Logged In",
    selector: (row) => row.loggedIn,
    sortable: true,
    width: "160px",
  },
  {
    name: "Booked Reservation",
    selector: (row) => row.bookedReservation,
    sortable: true,
    width: "200px",
  },
  {
    name: "Other Id",
    selector: (row) => row.otherId,
    sortable: true,
  },
  {
    name: "Membership Type",
    selector: (row) => row.membershipType,
    sortable: true,
    width: "200px",
  },
  {
    name: "Action",
    selector: (row) => row.action,
    sortable: true,
    width: "120px",
  },
];

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "0px",
      backgroundColor: "#004aad",
      color: "#fff",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "0px",
      },
      fontSize: "13px",
      color: "#fff",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "0px",
      },
      fontSize: "14px",
      padding: "10px",
    },
  },
};

export default function MemberList() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [members, setMembers] = useState([]);
  const [show, setShow] = useState(false);
  const [userDlt, setUserDlt] = useState("");
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);

    setPage(page);
  };

  const getMembers = async () => {
    setLoading(true);

    try {
      await axios
        .post(`/get-members/?limit=${limit}&page=${page}`, {}, adminConfig())
        .then((res) => {
          setLoading(false);
          if (res.data.status === true) {
            // message.success("fetched member success");
            setMembers(res.data.data);
            setPagination(res.data.pagination);
          } else {
            message.error("Data Not Found");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const CustomLoader = () => (
    <div
      style={{
        padding: "15px",
        background: "#495A71",
        color: "#fff",
        width: "100%",
        fontSize: "40px",
        textAlign: "center",
        minHeight: "350px",
        lineHeight: "400px",
      }}
    >
      <div>Loading...</div>
    </div>
  );
  const EmptyDataLoader = () => (
    <div
      style={{
        padding: "15px",
        background: "#495A71",
        color: "#fff",
        width: "100%",
        fontSize: "40px",
        textAlign: "center",
        minHeight: "350px",
        lineHeight: "400px",
      }}
    >
      <div>No data found...</div>
    </div>
  );

  const changePage = (newPage) => {
    setLoading(true);
    setPage(newPage);
  };
  const allMembers = () => {
    let allMembers = members.map((item, i) => {
      return {
        id: i,
        contract: item.contract,

        name: item.name,

        vacationClub: item.vacationClub,
        userType: item.userType,

        email: item.email,
        firstActivationDate: item.firstActivationDate,
        accountType: item.accountType,
        bookedReservation: item.bookedReservation,
        otherId: item.otherId,
        membershipType: item.membershipType,
        active: item.active,
        loggedIn: item.loggedIn,

        action: (
          <div className="action_but">
            <button
              type="button"
              className="act_del_but"
              // onClick={() => deleteMember(item._id)}
              onClick={() => confirmDelete(item._id)}
            >
              Delete
            </button>
          </div>
        ),
      };
    });
    return allMembers;
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const confirmDelete = (id) => {
    handleShow();
    setUserDlt(id);
  };
  const deleteMember = async () => {
    handleClose();

    let data = { userId: userDlt };
    await axios
      .post("/delete-member", data, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success("delete member success");
          getMembers();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
        message.error("delete member failed");
      });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Members Listing</h2>
              {members.length > 0 && (
                <DataTable
                  columns={columns}
                  data={allMembers()}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  onRowClicked={handleRowClicked}
                  selectableRows
                  selectableRowsComponent={Checkbox} // Pass the Checkbox component only
                  persistTableHead
                />
              )}

              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are You sure ?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={deleteMember}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const Checkbox = React.forwardRef(({ onClick, ...rest }, ref) => {
  return (
    <>
      <div className="form-check form_group p-3">
        <input
          type="checkbox"
          className="form-check-input"
          //style={{ height: '20px', width: '20px' }}
          ref={ref}
          id="html"
          selectRow={selectRow}
          onClick={onClick}
          {...rest}
        />
        <label className="form-check-label" id="booty-check" for="html" />
      </div>
    </>
  );
});

const selectRow = {
  mode: "checkbox",
  classes: "selected_row",
  bgColor: "red",
};
const handleRowClicked = {
  mode: "checkbox",
  classes: "selected_row",
  bgColor: "red",
};
